<template>

<div class="panel-container" ref="panelContainer">
	<img
		v-if="imageUrl"
		:src="imageUrl"
		ref="displayImage"
		:style="{
				width: canvasWidth+'px',
				height: canvasHeight+'px'
			}"
		v-on:click="$emit('click')">

	<template v-if="layers">
		<canvas
			ref="displayCanvas"
			:class="{'no-image' : !imageUrl}"
			:style="{
				width: canvasWidth+'px',
				height: canvasHeight+'px',
				display: 'inline-block',
				position: imageUrl ? 'absolute' : 'relative'
			}"
			:width="canvasWidth"
			:height="canvasHeight"
			v-on:click="$emit('click')">
		</canvas>
	</template>
</div>

</template>

<script type="text/javascript">

import { fabric } from 'fabric'
import FabricMixins from "@/mixins/FabricMixins.js"

export default {
	name: "ImageWithLayers",
	props: [
		"imageUrl",  // image url
		"layers",    // list of ImageDrawLayers
		"width",     // set width of image
		"height",
		"rerenderTrigger" 
	],
	mixins: [
		FabricMixins
	],
	data() {
		return {
			canvas: null,
			rect: null,
			context: null,
			canvasWidth: null,
			canvasHeight: null,
			lastPosition: {
				x: 0,
				y: 0
			},
		}
	},
	watch: {
		imageUrl() {
			this.initCanvas()
		},
		layers() {
			this.initCanvas()
		},
		rerenderTrigger() {
			this.initCanvas()
		}
	},
	methods: {
		initCanvas() {

			let vm = this
			//imgtag apparently loads full width first before updating, so a slight delay gives img tag time for styles to be set
			setTimeout(() => {

				//set canvas to match dimensions of img tag
				let dimensions = this.getImageDimensions()

				if (dimensions.width > 0) {
					vm.canvasWidth = dimensions.width
					vm.canvasHeight = dimensions.height
				}
				else {
					//get the parent container width
					let container = this.$refs.panelContainer

					vm.canvasWidth = container.innerWidth
				}

				let canvasRef = vm.$refs.displayCanvas

				// No canvas found? We can't draw on anything, return
				if (!canvasRef)
					return

				vm.renderLayers()

				vm.$emit('init',{dimensions})
			},500)
		},
		getNormalizedXY(position) {
			return {
				x: (position.x / this.rect.width * this.canvas.width) - this.rect.left,
				y: (position.y / this.rect.height * this.canvas.height) - this.rect.top,
			}
		},
		getImageDimensions() {
			let imgTag = this.$refs.displayImage

			if (!imgTag) {
				let width = 300, height = 300

				if (this.width)
					width = this.width
				else {
					let panelContainer = this.$refs.panelContainer

					if (panelContainer) 
						width = panelContainer.clientWidth
					
				}

				//set max width
				if (width > 1000)
					width = 1000

				height = width * .67

				return {
					width, height //default if no image exists
				}
			}

			return {
				width: imgTag.width,
				height: imgTag.height
			}
		},
		renderLayers() {
			/**
			 * Draws each layer on canvas
			 */
			 let vm = this

			vm.canvas = vm.$refs.displayCanvas
			vm.rect = vm.canvas.getBoundingClientRect()
			vm.context = vm.canvas.getContext("2d");

			vm.context.clearRect(0, 0, vm.canvas.width, vm.canvas.height);

			// Do nothing if no layers
			if (!this.layers || !this.layers.length)
				return


			if (vm.canvas) {

				// Draw each layer on the canvas
				this.layers
					.forEach(layer => {

						let object = JSON.parse(layer.layer_json)


						//calculate scale based on canvaswidth at time of drawing vs rendering canvas width
						let scale = object.canvasWidth / vm.canvasWidth

						/*
						let useWidth = this.canvasWidth    // canvas width we'll use when scaling
						let useHeight = this.canvasHeight  // canvas height we'll use when scaling

						// If the image has been rotated onto its y-axis, then
						// swap the height and width to keep the scales preserved
						if (layer.y_axis == 1) {
							useWidth = this.canvasHeight
							useHeight = this.canvasWidth
						}
						*/

						if ("strokes" in object && object.strokes) {
							object.strokes.forEach(stroke => {

								vm.context.lineWidth = stroke.strokeThickness / scale
								vm.context.strokeStyle = stroke.strokeColor
								vm.context.lineCap = "round"

								stroke.trail.forEach((position,index) => {

									//normalize the position with the canvas coordinates
									let normalizedXY = vm.getNormalizedXY(position)

									normalizedXY = position

									if (index > 0) {
										vm.context.beginPath()
										vm.context.moveTo(vm.lastPosition.x / scale , vm.lastPosition.y / scale)
										vm.context.lineTo(normalizedXY.x / scale, normalizedXY.y / scale)
										vm.context.stroke()

									}
									vm.lastPosition = normalizedXY
								})

							})
						}
					})
			}
		}
	},
	mounted() {
		//this.loadImage()
		this.initCanvas()
	}

}
</script>

<style type="text/css" scoped>

.panel-container {
	position: relative;
	text-align: left;
	overflow: hidden;
}

.panel-container img {
	position: relative;
	z-index: 1
}

canvas {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 2;
}

canvas.no-image {
	border: 1px solid gray;
}
</style>